import { render } from "./MyAssign.vue?vue&type=template&id=b258eeae&scoped=true"
import script from "./MyAssign.vue?vue&type=script&lang=js"
export * from "./MyAssign.vue?vue&type=script&lang=js"

import "./MyAssign.vue?vue&type=style&index=0&id=b258eeae&lang=less&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b258eeae"]])

export default __exports__